import { createApp } from 'vue'
// import Vue from 'vue';
import App from './App.vue'
import router from './router';

// import store from "../src/store"
// import { createStore } from 'vuex';
// import {BootstrapVue} from 'bootstrap-vue';


// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.min.css';

const vuetify = createVuetify({
    components,
    directives,
    icons: {
      iconfont: 'mdi', // default - only for display purposes
    },
  })
// const store = createStore({
//     state() {
//         return {};
//     }
// })
const app = createApp(App);
app.use(router);
app.use(vuetify);
// app.use(store)

// Vue.use(BootstrapVue);
app.mount('#app');

// new Vue({
//     router,
//     store,
//     render: h => h(App),
// }).$mount('#app')
